import moment from "moment";
import { BentoContact, NewBentoContact } from "schemas/dashboard";

import { DAYS_TO_DELAY_FOLLOWUP } from "constants/templates";
import { addBusinessDays } from "utils/time";

export const ReplyScoreLabel = (score: number) => {
  if (score < 60) {
    return "This email has a high chance of bouncing";
  } else if (score < 70) {
    return "This email has a low chance of bouncing";
  } else if (score < 88) {
    return "This contact has responded to creators within the last 90 days";
  } else if (score < 99) {
    return "This contact is used for partnerships/collaborations with creators";
  } else {
    return "This contact has responded with a positive intent within the last 90 days";
  }
};

export const getFollowUpEmailScheduledTime = (
  days: number = DAYS_TO_DELAY_FOLLOWUP,
  startFrom?: string | null,
) => {
  const start = startFrom ? moment(startFrom) : undefined;
  const x = addBusinessDays(days, start);
  return x.format("MMM DD");
};

export const setContactKey = (
  contact: BentoContact | NewBentoContact | null,
) => {
  if (!contact) return "";
  return (contact as BentoContact).id != null
    ? `id:${(contact as BentoContact).id}`
    : `email:${contact.email}`;
};

export const getContactKey = (key: string) => {
  if (key.startsWith("id:")) {
    return { id: key.replace("id:", "") };
  }
  if (key.startsWith("email:")) {
    return { email: key.replace("email:", "") };
  }
  return {};
};
